export enum GroupType {
  DumpsterGroup,
  CollectionPointGroup
}
